module.exports = __webpack_public_path__ + "static/media/scala.277125cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/backend/scala.png
// module id = 1523
// module chunks = 0